module.exports = __webpack_public_path__ + "img/icon-no-template.b1b08411.svg";